import React from "react";
import MenuOne from "./MenuLeft/MenuLeft";
import MenuTwo from "./MenuRight/MenuRight";
import "./MenuSec.css";

let LogoMenu = (
  <>
    <div className="astonMartin">
      <div className="svgMartin">
        <a href="blank" className="logoMartin">
          <h2>
            Aston<span>Martin</span>
          </h2>
        </a>
      </div>
    </div>
  </>
);

function MenuSec() {
  return (
    <>
      <div className="menuSection">
        <MenuOne />
        {LogoMenu}
        <MenuTwo />
      </div>
    </>
  );
}

export default MenuSec;
